import React from "react";
import getImagePath from "shared/util/getImagePath";

import Carousel, {
	CarouselItem,
} from "apps/payment/components/Carousel";
import { DESCRIPTIONS } from "apps/boosts/util/constants";


const Description = () => {
	const boostMascotRelativePath = "media/img/illustrations/wright-png/boost-mascot-teal.png";
	const boostMascot = `${getImagePath()}${boostMascotRelativePath}`;

	return (
		<div className="boostpackages-description">
			<img
				alt="step into the spotlight"
				className="boostpackages-description-image"
				src={boostMascot}
			/>
			<Carousel>
				{DESCRIPTIONS.map((description, index) => (
					<CarouselItem
						key={description.header}
						index={index}
						totalItemCount={DESCRIPTIONS.length}
					>
						<h2 className="boostpackages-description-header">
							{description.header}
						</h2>
						<p
							className="boostpackages-description-paragraph">
							{description.paragraph}
						</p>
					</CarouselItem>
				))}
			</Carousel>
		</div>
	);
};

export default Description;



// WEBPACK FOOTER //
// ./src/apps/boosts/components/ProductPackageScreen/Description.jsx